// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CheckoutForm container styles */
.checkout-form-container {
  display: flex;
  justify-content: center;
  margin-top: 5vh;
  margin-left: 20vw;
  margin-right: 20vw;
  padding: 1rem;
  border: 2px solid #333;
  background-color: #eee;
  border-radius: 1rem;
  width: 60vw;
}

.checkout-form-container h3 {
  margin-top: 0.5rem;
}

.form-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 750px;
}

.form-header {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  font-style: italic;
}

/* Responsive flex container for form rows */
.form-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/* Column styles for form inputs */
.form-column {
  flex: 1;
}

/* Half-width style for inputs */
.half-width {
  max-width: calc(50% - 1rem);
}

/* Third-width style for inputs */
.third-width {
  max-width: calc(33.333% - 1rem);
}

/* Full-width style for single column inputs */
.full-width {
  flex: 0 0 100%;
  max-width: 100%;
}

/* General input styles */
input {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  width: calc(100% - 1rem);
  font-size: 1.5rem;
  padding: 0.5rem;
}

/* Primary input style */
.input-primary {
  border-color: #4ae33c;
  font-size: 1.5rem;
  padding: 0.5rem;
}

/* Warning input style */
.input-warning {
  border-color: #247a97;
  font-size: 1.5rem;
  padding: 0.5rem;
}

/* Button styling */
.btn-primary {
  padding: 0.5rem;
  text-transform: uppercase;
  font-size: 1.25rem;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  background-color: #4ae33c;
  color: black;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}

/* Order created and failed message styles */
.order-created,
.order-failed {
  text-align: center;
}

.order-created {
  background-color: #f4f4f4;
  color: #247a97;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  margin-top: 2rem;
}

.order-created h1,
.order-created h2,
.order-created h4 {
  color: #247a97;
  margin-bottom: 1rem;
  font-size: 2.5rem;
}

.order-created h1 {
  font-weight: bold;
}

.order-created h2,
.order-created h4 {
  font-size: 1.5rem;
}

.order-created button.return-to-account-btn {
  background-color: #76bbe9;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s;
}

.order-created button.return-to-account-btn:hover {
  background-color: #247a97;
}

@media screen and (max-width: 991px) {
  .checkout-form-container {
    margin-left: 10vw;
    margin-right: 10vw;
    width: 80vw;
  }

  .form-column {
    width: 80vw;
  }

  .form-wrapper h1 {
    font-size: 5rem;
  }

  .checkout-form-container h3 {
    font-size: 2.5rem;
  }

  .btn-primary {
    padding: 0.5rem;
    text-transform: uppercase;
    font-size: 3rem;
    font-weight: 700;
    border: none;
    border-radius: 10px;
    background-color: #4ae33c;
    color: black;
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .checkout-form-container .input-primary,
  .checkout-form-container .input-warning,
  .checkout-form-container .input-bordered {
    margin-bottom: 0.5rem;
    font-size: 2.5rem;
  }

  .order-created h1 {
    font-size: 5rem;
  }

  .order-created h2,
  .order-created h4 {
    font-size: 3rem;
  }

  .order-created button.return-to-account-btn {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/CheckoutPage.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,OAAO;AACT;;AAEA,gCAAgC;AAChC;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;;EAEE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;;IAGE,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* CheckoutForm container styles */\n.checkout-form-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 5vh;\n  margin-left: 20vw;\n  margin-right: 20vw;\n  padding: 1rem;\n  border: 2px solid #333;\n  background-color: #eee;\n  border-radius: 1rem;\n  width: 60vw;\n}\n\n.checkout-form-container h3 {\n  margin-top: 0.5rem;\n}\n\n.form-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  max-width: 750px;\n}\n\n.form-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  font-style: italic;\n}\n\n/* Responsive flex container for form rows */\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n/* Column styles for form inputs */\n.form-column {\n  flex: 1;\n}\n\n/* Half-width style for inputs */\n.half-width {\n  max-width: calc(50% - 1rem);\n}\n\n/* Third-width style for inputs */\n.third-width {\n  max-width: calc(33.333% - 1rem);\n}\n\n/* Full-width style for single column inputs */\n.full-width {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n/* General input styles */\ninput {\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 10px;\n  width: calc(100% - 1rem);\n  font-size: 1.5rem;\n  padding: 0.5rem;\n}\n\n/* Primary input style */\n.input-primary {\n  border-color: #4ae33c;\n  font-size: 1.5rem;\n  padding: 0.5rem;\n}\n\n/* Warning input style */\n.input-warning {\n  border-color: #247a97;\n  font-size: 1.5rem;\n  padding: 0.5rem;\n}\n\n/* Button styling */\n.btn-primary {\n  padding: 0.5rem;\n  text-transform: uppercase;\n  font-size: 1.25rem;\n  font-weight: 700;\n  border: none;\n  border-radius: 10px;\n  background-color: #4ae33c;\n  color: black;\n  cursor: pointer;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n/* Order created and failed message styles */\n.order-created,\n.order-failed {\n  text-align: center;\n}\n\n.order-created {\n  background-color: #f4f4f4;\n  color: #247a97;\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.order-created h1,\n.order-created h2,\n.order-created h4 {\n  color: #247a97;\n  margin-bottom: 1rem;\n  font-size: 2.5rem;\n}\n\n.order-created h1 {\n  font-weight: bold;\n}\n\n.order-created h2,\n.order-created h4 {\n  font-size: 1.5rem;\n}\n\n.order-created button.return-to-account-btn {\n  background-color: #76bbe9;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.order-created button.return-to-account-btn:hover {\n  background-color: #247a97;\n}\n\n@media screen and (max-width: 991px) {\n  .checkout-form-container {\n    margin-left: 10vw;\n    margin-right: 10vw;\n    width: 80vw;\n  }\n\n  .form-column {\n    width: 80vw;\n  }\n\n  .form-wrapper h1 {\n    font-size: 5rem;\n  }\n\n  .checkout-form-container h3 {\n    font-size: 2.5rem;\n  }\n\n  .btn-primary {\n    padding: 0.5rem;\n    text-transform: uppercase;\n    font-size: 3rem;\n    font-weight: 700;\n    border: none;\n    border-radius: 10px;\n    background-color: #4ae33c;\n    color: black;\n    cursor: pointer;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .checkout-form-container .input-primary,\n  .checkout-form-container .input-warning,\n  .checkout-form-container .input-bordered {\n    margin-bottom: 0.5rem;\n    font-size: 2.5rem;\n  }\n\n  .order-created h1 {\n    font-size: 5rem;\n  }\n\n  .order-created h2,\n  .order-created h4 {\n    font-size: 3rem;\n  }\n\n  .order-created button.return-to-account-btn {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
